import { Table } from '@mantine/core';
import PropTypes from 'prop-types';
import classes from './tableSimple.module.css';

const TableSimple = (props) => {
  const {
    data = {},
  } = props;

  return (
    <div className={classes.tableContainer}>
      <Table
        striped={true}
        withTableBorder
        withRowBorders
        withColumnBorders
        verticalSpacing="md"
        layout='fixed'
        data={data}
      />
    </div>
  );
};

TableSimple.propTypes = {
  data: PropTypes.object.isRequired,
};

export default TableSimple;
